module.exports = __webpack_public_path__ + "img/list01.f72dbb27.jpg";